import AssociationRolesSelect from './AssociationRolesSelect.component';

export default AssociationRolesSelect;